import _ from 'lodash';
import { replaceHighlightTag } from '@patsnap-utils/highlight';
export const name = 'AN_UNSTANDARD.render';
// 默认显示模板
function renderDefault(h, renderOpts, params) {
    const { row, column } = params;
    const prop = _.get(column, 'property');
    const { _highlightMixin_hlText } = renderOpts;
    const { PN, PATENT_ID } = row || {};
    const cellValue = _.get(row, prop);
    const links = _.map(cellValue, ({ OFFICIAL, EN }) => {
        let innerHTML = _highlightMixin_hlText(OFFICIAL);
        if (EN) {
            innerHTML = `${innerHTML}<span>${_highlightMixin_hlText(`(${EN})`)}</span>`;
        }
        return <span title={replaceHighlightTag(OFFICIAL)} 
        // @ts-ignore
        domProps={{ innerHTML }} target="_blank" data-link-type={prop} data-link-data={OFFICIAL} data-patent-id={PATENT_ID} data-patent-no={PN}/>;
    });
    return [
        <div class="xtable-cell-render" cell-type={prop} cell-render={name}>
            {links}
        </div>,
    ];
}
// 导出模板，例如导出插槽中自定义的内容
function exportMethod(params) {
    const { row, column } = params;
    const result = _.map(row[column.property] || [], ({ OFFICIAL, EN }) => {
        return `${OFFICIAL}${EN ? `(${EN})` : ''}`;
    });
    return result.join(',');
}
export default {
    renderDefault,
    exportMethod,
};
